var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.toast)?_c('ToastComponent',[_c('div',{key:_vm.toast.id,staticClass:"text",class:_vm.setClass,on:{"click":_vm.onToastClose}},[_vm._v(_vm._s(_vm.toast.text))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }